import controller from './storeAdd.controller';
import template from './storeAdd.html';

const storeAddComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default storeAddComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/storeAdd/storeAdd.component.js
 **/